import { render, staticRenderFns } from "./receiptAdd.vue?vue&type=template&id=715e6a81"
import script from "./receiptAdd.vue?vue&type=script&lang=js"
export * from "./receiptAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports